// extracted by mini-css-extract-plugin
export var backdrop = "modal-service-module--backdrop--1a0ae";
export var checked = "modal-service-module--checked--6a7b8";
export var modalService = "modal-service-module--modal-service--e51e2";
export var modalServiceBodyOverflow = "modal-service-module--modalServiceBodyOverflow--ec39f";
export var modalServiceContent = "modal-service-module--modal-service-content--ffa3a";
export var modalServiceHeader = "modal-service-module--modal-service-header--4a949";
export var modalServiceHeaderTitle = "modal-service-module--modal-service-header-title--e36fe";
export var modalServiceInner = "modal-service-module--modalServiceInner--ba8c8";
export var unchecked = "modal-service-module--unchecked--45158";